/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Category from '../Category'
import NewCategory from '../NewCategory'
import EditCategory from '../EditCategory'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/categories',
    name: 'category',
    component: Category,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/categories/create',
    name: 'create-category',
    component: NewCategory,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/categories/edit/:id',
    name: 'edit-category',
    component: EditCategory,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/category/routes/index.js